/**
 * 분석 마일스톤 1회성 추적 — first_fire/first_purchase/rebirth_ready 등 "계정 생애 1회" 퍼널 이벤트의
 * 중복 발화를 막는다(GA4 funnel 오염 방지). 순수 도메인 무관(Set 래퍼) — Phaser/분석 sink 무의존.
 *
 * 영속: SaveData.analyticsMilestones(string[])로 직렬화(SaveCodec) + 번들 스왑(saveSwap)으로 reload 복원.
 * 호출자 규약: `if (ctx.analyticsMilestones().markOnce(key)) ctx.analytics().log(key)`.
 */
export class AnalyticsMilestoneController {
  private readonly fired: Set<string>;

  constructor(initial?: Iterable<string>) {
    this.fired = new Set(initial);
  }

  /** SaveData.analyticsMilestones(string[])에서 복원. undefined(신규 계정)이면 빈 Set으로 초기화. */
  static fromState(state: readonly string[] | undefined): AnalyticsMilestoneController {
    return new AnalyticsMilestoneController(state ?? []);
  }

  /** 첫 호출만 true(+기록), 이후 false. 1회성 이벤트 dedup의 단일 게이트. */
  markOnce(key: string): boolean {
    if (this.fired.has(key)) return false;
    this.fired.add(key);
    return true;
  }

  /** 이미 발화한 마일스톤인지 (markOnce 부수효과 없이 조회). */
  has(key: string): boolean {
    return this.fired.has(key);
  }

  /** 발화된 마일스톤 키 배열을 반환. SaveCodec이 SaveData.analyticsMilestones에 직렬화한다. */
  toState(): string[] {
    return [...this.fired];
  }
}
